export default {
    HEADER_HEIGHT: { base: '56px', lg: '80px' },
    NAVBAR_HEIGHT: { base: '56px', lg: '132px' },
    FOOTER_HEIGHT: { base: '333px', lg: '541px' },
    ENGRAVING_NAVBAR_HEIGHT: { base: '74px', lg: '132px' },
    CONFIGURATOR: {
        MENU_HEIGHT: { base: '4rem', lg: '5rem' },
        TABS_HEIGHT: { base: '3rem' },
    }
}